import React from 'react';
import TransactionAllocator, {
  Transaction,
} from 'components/TransactionAllocator';
import { CurrencyCode, FxDataFeed } from 'further-types/lp/vehicle';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../hooks/usePartnerTransfersForm';
import { Box, styled } from '@mui/material';

const ContentColumn = styled(Box)(({ theme }) => ({
  padding: theme.spacing(
    0,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
  ),
}));

type CapitalActionTransactionAllocatorProps = {
  actionId: string;
  transactions: Array<Transaction>;
  transactionTypeOptions: Array<{ label: string; value: string | null }>;
  vehicle: {
    _id: string;
    baseCurrency: CurrencyCode;
    fxDataFeed: FxDataFeed;
  };
  savedTransactions?: Record<string, Array<Transaction>>;
};

const CapitalActionTransactionAllocator: React.FC<
  CapitalActionTransactionAllocatorProps
> = ({
  actionId,
  transactions,
  transactionTypeOptions,
  vehicle,
  savedTransactions,
}) => {
  const { setValue, getValues } = useFormContext<PartnerTransfersFormValues>();

  const currentTransactions = savedTransactions?.[actionId] ?? transactions;

  const onTransactionChange = (updatedTransactions: Array<Transaction>) => {
    const existingTransactions = getValues('capitalActionTransactions') ?? {};

    setValue('capitalActionTransactions', {
      ...(existingTransactions ?? {}),
      [actionId]: updatedTransactions.map((t) => ({
        ...t,
        id: t.id?.toString(),
        amountExVatLcy: t.amountExVatLcy ?? 0,
        amountIncVatLcy: t.amountIncVatLcy ?? 0,
        vatRate: 0,
      })),
    });
  };

  return (
    <ContentColumn>
      <TransactionAllocator
        transactionTypeOptions={transactionTypeOptions}
        transactions={currentTransactions}
        onChange={onTransactionChange}
        transactionCurrency={vehicle.baseCurrency}
        fxRate={null}
        vehicle={vehicle}
      />
    </ContentColumn>
  );
};

export default CapitalActionTransactionAllocator;
